import dayjs from 'dayjs';

import { sanitizeDownloadBasename } from './callApi';

export function getTrafficCurvePercents(data, precision = 1) {
  const total = data.reduce((sum, value) => sum + (Number(value) || 0), 0);
  if (!total) {
    return data.map(() => 0);
  }
  const scale = 10**precision;
  return data.map(value => Math.round((Number(value) || 0)*100*scale/total)/scale);
}

function csvEscape(value) {
  const text = String(value ?? '');
  return /[",\n\r]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text;
}

export function downloadCsv(filename, rows) {
  const content = '\uFEFF' + rows.map(row => row.map(csvEscape).join(',')).join('\n');
  const blob = new Blob([content], {type: 'text/csv;charset=utf-8;'});
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.setAttribute('download', filename);
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { a.parentNode.removeChild(a); window.URL.revokeObjectURL(url); }, 200);
}

export function downloadTrafficCurveCsv(data, basename) {
  const rows = [
    ['小时', '百分比'],
    ...getTrafficCurvePercents(data, 2).map((pct, hour) => [hour, `${pct.toFixed(2)}%`]),
  ];
  const filename = `${sanitizeDownloadBasename(basename)}-${dayjs().format('MMDD_HHmmss')}.csv`;
  downloadCsv(filename, rows);
}

export function downloadHourlyPlanCsv(data, basename) {
  const rows = [
    ['日期', '小时', '数量'],
    ...(data?.rows || []).map(row => [
      data.date || '',
      `${String(row.hour).padStart(2, '0')}:00`,
      Number(row.count) || 0,
    ]),
  ];
  const filename = `${sanitizeDownloadBasename(basename)}-${dayjs().format('MMDD_HHmmss')}.csv`;
  downloadCsv(filename, rows);
}
